import { actions, store, history } from '@sparky/framework'
import { VIEW_MANAGE_TENANT } from '../../common/constants/GlobalConstants'

export const RUNNING = 'running'

export const showActivate = (app_id: string) => {
  actions.openCommonModule(`${VIEW_MANAGE_TENANT}/instances/${app_id}`, store.stateRef.current.auth?.tsg_id)
}

export const showUnifiedActivation = (path: string) => {
  history.push(path)
}

export const showRenameInstance = (tenant_id: string) => {
  actions.openCommonModule(`${VIEW_MANAGE_TENANT}/rename/${tenant_id}`, store.stateRef.current.auth?.tsg_id)
}

export const isRunningStatus = ({ status }: { status?: string }): boolean => (
  status === RUNNING
)

export const isInProgressStatus = ({ status, provisioning_status }: { status?: string, provisioning_status?: string }): boolean => Boolean(
  (status && ['pending', 'provisioning', 'error'].includes(status)) ||
  (provisioning_status && ['provisioning', 'initializing', 'error'].includes(provisioning_status))
)

export const isNonemptyArray = (arr: Array<any> | any): arr is NonNullable<Array<any>> => Array.isArray(arr) && arr.length > 0
